import {useTranslation} from 'react-i18next';
import StatusLabel from '../StatusLabel/StatusLabel';
import {TEticketTicket} from '../../../redux/eTicket/eTicket.type';
import {getHourMinutes, getDateFormat} from '../../../library/dates';
import ticketOpenImg from '../../../assets/images/eTicket/ticketOpen.png';
import ticketScannedImg from '../../../assets/images/eTicket/ticketScanned.png';

interface TicketScanStatusProps {
    ticket: TEticketTicket;
}

function TicketScanStatus({ticket}: TicketScanStatusProps) {
    const {t} = useTranslation('eTicket');

    if(ticket.scanned) {
        const scannedAt = ticket.scanTs && `${getHourMinutes(ticket.scanTs)} • ${getDateFormat(ticket.scanTs, 'D.M')}`;
        const text = scannedAt ? `${t('statusScanned')} - ${scannedAt}` : t('statusScanned');
        return <StatusLabel color="scanned" image={ticketScannedImg} imageShiftY="9px" text={text} data-cy="ticket-scan-status" />;
    }

    return <StatusLabel color="brand" image={ticketOpenImg} imagePosition="end" imageShiftY="9px" text={t('statusOpen')} data-cy="ticket-scan-status" />;
}

export default TicketScanStatus;
